<template>
        <div class="row justify-content-center">
            <div class="col-lg-5 col-md-7">
                <div class="card bg-secondary shadow border-0">
                    <div class="card-body px-lg-5 py-lg-5">
                        <form role="form" @submit.prevent="login" >
                            <base-input class="input-group-alternative mb-3"
                                        placeholder="Email"
                                        addon-left-icon="ni ni-email-83"
                                        v-model="username">
                            </base-input>

                            <base-input class="input-group-alternative"
                                        placeholder="Password"
                                        type="password"
                                        addon-left-icon="ni ni-lock-circle-open"
                                        v-model="password">
                            </base-input>

                            <base-checkbox class="custom-control-alternative">
                                <span class="text-muted">Remember me</span>
                            </base-checkbox>
                            <div class="text-center">
                                <base-button type="primary" nativeType="submit" class="my-4">Sign in</base-button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
  export default {
    name: 'login',
    data() {
        return {
          username: '',
          password: '',
          err: null
        }
    },
    methods:{
        async login(){
          let data = {
            username: this.username,
            password: this.password
          }
          await this.$store.dispatch('update_request')
          let res = await this.$http.post('/users/login', data).catch(() => {
            this.$store.dispatch('update_error')
            this.$notify({type: 'danger',message:"Login error"})
            localStorage.removeItem('token')
            this.$router.push('/login')
          })
         
          let token = res.data.token
          let currentuser = res.data.body
          localStorage.setItem('token', token)
          await this.$store.dispatch('update_success',token)
          await this.$store.dispatch('update_user',currentuser)
          this.$http.defaults.headers.common['Authorization'] = 'jwt ' + token
          this.$router.push('/events')
        }
    }
  }
</script>
<style>
</style>
